var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSextile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.392,46.975H57.263l25.76-25.761c1.172-1.171,1.172-3.071,0-4.242c-1.171-1.172-3.071-1.172-4.243,0l-28.77,28.77  l-28.77-28.77c-1.172-1.172-3.072-1.172-4.243,0c-1.172,1.171-1.172,3.071,0,4.242l25.76,25.761H10.608c-1.657,0-3,1.343-3,3  s1.343,3,3,3h32.189l-25.799,25.8c-1.172,1.171-1.172,3.071,0,4.242c0.585,0.586,1.353,0.879,2.121,0.879  c0.768,0,1.536-0.293,2.121-0.879l28.77-28.77l28.771,28.77c0.585,0.586,1.354,0.879,2.121,0.879s1.536-0.293,2.122-0.879  c1.171-1.171,1.171-3.071,0-4.242l-25.8-25.8h32.169c1.657,0,3-1.343,3-3S91.048,46.975,89.392,46.975z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSextile);
export default __webpack_public_path__ + "static/media/sextile.6318ac7173cdbb958e8240f8f4afc691.svg";
export { ForwardRef as ReactComponent };